import noUiSlider from 'nouislider';
window.noUiSlider = noUiSlider;
import wNumb from "wnumb";
window.wNumb = wNumb;

function paginationLinkFix() {
    $('.pagination a').each(function () {
        let href = $(this).attr('href');
        let hrefStart = '';

        href = href.split('?filters=');
        if (href.length == 2) {
            hrefStart = href[0];
            href = href[1].split('%3A').join(':');
            href = href.split('%3B');

            if (href.length > 1) {
                href = href.join(';')
            } else {
                href = href.join('')
            }

            href = href.split('%2C');
            if (href.length > 1) {
                href = href.join(',')
            } else {
                href = href.join('')
            }

            href = hrefStart + '?filters=' + href;
        } else {
            href = href.join('');
        }
        $(this).attr('href', href);
    });
}

function filtersToolsCount() {
    let countCheckInput = 0;
    let countCheckBlock = 0;

    $('.filters_tools').each(function () {
        $(this).find('input').each(function () {
            if ($(this).is(':checked')) {
                countCheckInput++;
                countCheckBlock++;
            }
        })

        if (countCheckInput != 0) {
            $('.js__count_filter_active').text('(' + countCheckInput + ')')
                .addClass('js_active');
        } else {
            $('.js__count_filter_active').text('')
                .removeClass('js_active');
        }

        if (countCheckBlock != 0) {
            $(this).find('.js__filters_tools').text(countCheckBlock)
                .addClass('js_active');

            countCheckBlock = 0;
        } else {
            $(this).find('.js__filters_tools').text('')
                .removeClass('js_active');
        }
    });
}

window.filtersToolsCount = filtersToolsCount;

$(document).ready(function () {
    var rowType = localStorage.getItem('rowType');

    $(document).on('click', '.js__tolerances_fun button', function () {
        const nameButton = $(this).attr('data-name');
        const parent = $(this).closest('.js__tolerances_fun');
        const input = $(this).closest('.js__tolerances_fun').find('.js__tolerances_count_input');
        const maxPrise = input.attr('data-maxCount');
        const minPrise = input.attr('data-minCount');
        const value = Number(input.val());
        let newValue = value;

        $(this).closest('.js__tolerances_fun').find('button').removeClass('disabled');

        if (nameButton == 'count_plus') {
            if (maxPrise && (maxPrise <= value)) {
                input.val(maxPrise);
                $(this).addClass('disabled');
            } else {
                if (value + 0.1 == maxPrise) {
                    newValue = value + 0.1;
                    input.val(newValue.toFixed(1));
                    $(this).addClass('disabled');
                } else {
                    newValue = value + 0.1;
                    input.val(newValue.toFixed(1));
                }
            }
        } else {
            if (minPrise && (minPrise >= value)) {
                input.val(minPrise);
                $(this).addClass('disabled');
            } else if (value > 0.1) {
                if (value - 0.1 == 0.1) {
                    newValue = value - 0.1;
                    input.val(newValue.toFixed(1));
                    $(this).addClass('disabled');
                } else {
                    newValue = value - 0.1;
                    input.val(newValue.toFixed(1));
                }
            }
        }
    });

    function areValuesInRange(value1, value2, tolerances) {
        const num1 = parseFloat(value1.replace(',', '.'));
        const num2 = parseFloat(value2.replace(',', '.'));
        return Math.abs(num1 - num2) <= tolerances;
    }

    $(document).on('click', '.js__tolerances_btn', function () {
        const parent = $(this).closest('.js_open_filters');

        if ($(window).width() > 800) {
            const oeNumber = ($('.js_load_oeFilters').length == 1) ? true : false;
            submitFilters(false, false, false, oeNumber);
            $('.filter_separator').addClass('js_sheet');
        } else {
            const oeNumber = ($('.js_load_oeFilters').length == 1) ? true : false;
            const scrollFilters = $('.filter_block_main').scrollTop();
            submitFilters(false, true, scrollFilters, oeNumber);
            $('.filter_separator').addClass('js_sheet');
        }
    });

    $(document).on('keyup', '.js__search_char', function () {
        var filter = $(this).val().trim().toLowerCase();
        $(this).closest('.js__search_block')
            .find('.input_wrapper label')
            .each(function () {
                if ($(this).text().toLowerCase().search(new RegExp(filter, "i")) < 0) {
                    $(this).closest('.input_wrapper').hide();
                } else {
                    $(this).closest('.input_wrapper').show()
                }
            });

        if (filter == "") {
            $(this).closest('.input_wrapper').show()
        }
    });

    $(document).on('click', '.js__row_type', function () {
        $('.js__row_type').removeClass('js__active');
        $(this).addClass('js__active');
        const type = $(this).attr('data-type');
        if (type == 'row') {
            $('.tile_item_wrap').addClass('row_tile js_row_tile');
            localStorage.setItem('rowType', 'row');
            alignmentTileGlobal('row');
            $('.header_table').addClass('js__active');
        } else {
            $('.tile_item_wrap').removeClass('row_tile js_row_tile');
            localStorage.setItem('rowType', 'rows');
            alignmentTileGlobal('rows');
            $('.header_table').removeClass('js__active');
        }
    });

    if (rowType === null) {
        localStorage.setItem('rowType', 'rows');
        $('.js__row_type[data-type="rows"]').trigger('click');
    } else if (rowType == 'row') {
        $('.js__row_type[data-type="row"]').trigger('click');
    } else {
        $('.js__row_type[data-type="rows"]').trigger('click');
    }

    $(document).on('click', '.js_button_filters', function () {
        const parentBlock = $(this).closest('.filters_tools');
        parentBlock.toggleClass('js_open_tools_filter');
    });

    $(document).on('click', '.js__open_filter', function () {
        $('body').addClass('overflow_hidden');
        const buttonCloseFilters = `<button type="button" class="close_filter js_close_filter">
             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path data-name="cross" d="M.227 1.335a.8.8 0 0 1 0-1.11.8.8 0 0 1 1.11 0L8 6.9 14.67.225a.781.781 0 0 1 1.1 1.11L9.108 8l6.661 6.67a.781.781 0 0 1-1.1 1.11L8 9.1l-6.661 6.67a.8.8 0 0 1-1.11 0 .8.8 0 0 1 0-1.11L6.888 8z" transform="translate(-.002)" style="fill:#494b55"/>
            </svg>
        </button>`;

        const filterSubmitMob = `<div class="mobile_tools_filter js_send_filter_block">
         <button type="button" class="js__clear_filter">
            ${successText['reset_filter']}
        </button>
        <button type="button" class="js_send_filter">
            ${successText['send_filter']}
        </button>
        </div>`;

        $('.filter_block_main').addClass('js_open').append(buttonCloseFilters).append(filterSubmitMob);
    });

    if ($(window).width() > 800) {
        $(document).on('change', '.js__trigger_item', function (e) {
            if ($(this).attr('data-idgroupchar') == "marks" && !$(this).is(':checked')) {
                const valueModel = $(this).val()
                $(`.js__trigger_item[data-brand_id=${valueModel}]`)
                    .attr('checked', false);
            }
            const oeNumber = ($('.js_load_oeFilters').length == 1) ? true : false;
            submitFilters(false, false, false, oeNumber);
            $('.filter_separator').addClass('js_sheet');
        });
    } else {
        $(document).on('change', '.js__trigger_item', function (e) {
            if ($(this).attr('data-idgroupchar') == "marks" && !$(this).is(':checked')) {
                const valueModel = $(this).val()
                $(`.js__trigger_item[data-brand_id=${valueModel}]`)
                    .attr('checked', false);
            }
            const oeNumber = ($('.js_load_oeFilters').length == 1) ? true : false;
            const scrollFilters = $('.filter_block_main').scrollTop();
            submitFilters(false, true, scrollFilters, oeNumber);
            $('.filter_separator').addClass('js_sheet');
        });
    }

    $(document).on('click', '.js_close_filter, .js_send_filter', function () {
        $('.filter_block_main').removeClass('js_open');
        $('.close_filter, .js_send_filter_block').remove();
        $('body').removeClass('overflow_hidden');
    });

    $(document).on('click', '#do_price_range', function (e) {
        e.stopPropagation();
        e.preventDefault();
        submitFilters(true, false, false, false, min_price, max_price);
    });

    $(document).on('click', '.js__clear_filter', function (e) {
        e.stopPropagation();
        e.preventDefault();
        const oeNumber = ($('.js_load_oeFilters').length == 1) ? true : false;
        $('.filter_separator').addClass('js_sheet');

        submitFilters(false, false, false, oeNumber, false, false, true);
    });

    $(document).on('click', '.js__clear_item_filters', function () {
        const id = $(this).attr('data-id');
        const nameGroup = $(this).attr('data-nameGroup');

        if (nameGroup == 'car') {
            if (id != 'all') {
                $(`.js__trigger_item[data-idGroupChar=${nameGroup}][data-id=all]`).trigger('click');
            }
        } else {
            $(`.js__trigger_item[data-idGroupChar=${nameGroup}][data-id=${id}]`).trigger('click');
            $(`.js__tolerances_trigger_item[data-idGroupChar=${nameGroup}][data-id=${id}]`).trigger('click');
        }
    })

    function rangePrice() {
        var sliderPrice = document.getElementById('js_range_slider'),
            input_min = document.getElementById('input_min_price'),
            input_max = document.getElementById('input_max_price'),
            inputs = [input_min, input_max],
            step = 1,
            min_price = Number(input_min.getAttribute('data-min')),
            max_price = Number(input_max.getAttribute('data-max')),
            min_selected_price = Number(input_min.getAttribute('data-select-min')),
            max_selected_price = Number(input_max.getAttribute('data-select-max'));
        if (sliderPrice) {
            if (min_price == max_price) {
                $('.js__prise_filters').removeClass('js_open_tools_filter').hide();
            } else {
                noUiSlider.create(sliderPrice, {
                    start: [min_selected_price, max_selected_price],
                    connect: true,
                    tooltips: [wNumb({
                        mark: '.',
                        thousand: ' ',
                        suffix: ' грн.',
                        decimals: 0,
                    }), wNumb({
                        mark: '.',
                        thousand: ' ',
                        suffix: ' грн.',
                        decimals: 0,
                    })],
                    range: {
                        'min': min_price,
                        'max': max_price,
                    },
                    step: step,
                });
                sliderPrice.noUiSlider.on('update', function (values, handle) {

                    let data_start_min = 0;
                    let data_start_max = 0;

                    if (min_price != undefined) {
                        data_start_min = min_price;
                    }
                    if (max_price != undefined) {
                        data_start_max = max_price;
                    }
                    if (data_start_min != values[0]) {
                        inputs[0].value = values[0];
                    } else {
                        inputs[0].value = ''
                    }
                    if (data_start_max != values[1]) {
                        inputs[1].value = values[1];
                    } else {
                        inputs[1].value = ''
                    }
                });
                inputs.forEach(function (input, handle) {
                    input.addEventListener('change', function () {
                        sliderPrice.noUiSlider.setHandle(handle, this.value);
                    });

                    input.addEventListener('keydown', function (e) {
                        var values = sliderPrice.noUiSlider.get();
                        var value = Number(values[handle]);
                        var steps = sliderPrice.noUiSlider.steps();
                        var step = steps[handle];
                        var position;
                        switch (e.which) {
                            case 13:
                                sliderPrice.noUiSlider.setHandle(handle, this.value);
                                break;
                            case 38:
                                position = step[1];
                                if (position === false) {
                                    position = 1;
                                }
                                if (position !== null) {
                                    sliderPrice.noUiSlider.setHandle(handle, value +
                                        position);
                                }
                                break;
                            case 40:
                                position = step[0];
                                if (position === false) {
                                    position = 1;
                                }
                                if (position !== null) {
                                    sliderPrice.noUiSlider.setHandle(handle, value -
                                        position);
                                }
                                break;
                        }
                    });
                });
            }
        }
    }

    function submitFilters(click_on_button = false, typePage = false, scrollWrapFilters = false, pageOe, min, max, removeFilters = false) {
        var array = {};
        array.series = [];
        array.min_price = '';
        array.max_price = '';
        array.vals = [];
        array.available = 0;
        array.on_order = 0;
        array.chars = {}

        $(".js_filter_char").each(function () {
            if ($(this).is(":checked")) {
                let idChar = $(this).val();
                let idParentChar = $(this).attr('data-idGroupChar');
                let string = '';
                if (array.chars[idParentChar]) {
                    string = array.chars[idParentChar];
                    string += `,${idChar}`;
                } else {
                    string += idChar;
                }
                array.chars[idParentChar] = string;
            }
        });

        var selected_min_price = parseInt($('#input_min_price').val()),
            start_min_price = parseInt($('#input_min_price').attr('data-min')),
            selected_max_price = (parseInt($('#input_max_price').val())),
            start_max_price = parseInt($('#input_max_price').attr('data-max'));

        if (isNaN(selected_max_price) && isNaN(selected_min_price)) {
            delete array.max_price;
            delete array.min_price;
        } else if (isNaN(selected_min_price)) {
            array.min_price = start_min_price;
        } else if (isNaN(selected_max_price)) {
            array.max_price = start_max_price;
        }
        if (!isNaN(selected_max_price) && selected_max_price) {
            array.max_price = selected_max_price;
        }
        if (!isNaN(selected_min_price) && selected_min_price) {
            array.min_price = selected_min_price;
        }

        if (array.vals.length < 1) {
            delete array.vals;
        }
        if (array.available == 0) {
            delete array.available;
        }
        if (array.on_order == 0) {
            delete array.on_order;
        }

        let stringChar = "";
        let stringPrice = "";

        for (let item in array) {
            if (item == 'chars') {
                for (let itemChars in array[item]) {
                    if (stringChar != "") {
                        stringChar = stringChar + ';' + `${itemChars}:${array[item][itemChars]}`;
                    } else {
                        stringChar = `${itemChars}:${array[item][itemChars]}`;
                    }
                }
            } else if (item == "min_price") {
                if (array[item] != "") {
                    stringPrice += `price:${array.min_price}`;
                }
            } else if (item == "max_price") {
                if (array[item] != "") {
                    stringPrice += `-${array.max_price};`;
                }
            }
        }

        if (removeFilters) {
            if ($('.js__clear_item_filters[data-namegroup=car]').length > 0) {
                filters = "car:all";
            } else {
                filters = undefined;
            }
        } else {
            filters = JSON.stringify(stringPrice + stringChar);
        }

        if (typeof filters !== 'undefined') {
            filters = filters.replace(/"/g, '');
        } else {
            filters = ""
        }

        var url = main_url;

        if (typeof search_page === 'undefined') {
            if (filters != "") {
                url = url + "?filters=" + filters;
                if (sorting != '' && sorting != 'default') {
                    url = url + "&sorting=" + sorting;
                }
            } else {
                filters = "";
                if (sorting != '' && sorting != 'default') {
                    url = url + "?sorting=" + sorting;
                }
            }
        } else {
            if (filters != "") {
                url = url + "&filters=" + filters;
                if (sorting != '' && sorting != 'default') {
                    url = url + "&sorting=" + sorting;
                }
            } else {
                filters = "";
                if (sorting != '' && sorting != 'default') {
                    url = url + "?sorting=" + sorting;
                }
            }
        }

        history.pushState({}, '', url);

        const type_row_naw = localStorage.getItem('rowType');

        if (pageOe) {
            $.post(request.loadOeGoods, {
                "filters": filters,
                "lang": lang,
                "oe": oe
            }, function (data) {
                if (data.status == 'ok') {
                    $('.js__goods').empty().append(data.html);
                    $('.js__count').empty().append(data.count);

                    if ($(window).width() >= 769) {
                        if (type_row_naw == 'row') {
                            $('.tile_item_wrap').addClass('row_tile js_row_tile');
                            alignmentTileGlobal('row');
                        } else {
                            alignmentTileGlobal('rows');
                        }
                    } else {
                        alignmentTileGlobal('rows');
                    }

                    lazyLoad();

                    if ($('.js__goods .pagination').length != 0) {
                        paginationLinkFix();
                    }
                    loadOeFilters(filters, typePage, scrollWrapFilters);
                }
            });
        } else if (typeof load_dis_cars !== 'undefined' && load_dis_cars) {
            $.post(request.loadDisCars, {
                "filters": filters,
                "lang": lang,
            }, function (data) {
                if (data.status == 'ok') {
                    $(".js__disassembled_auto_list").empty().append(data.html);
                    lazyLoad();

                    if ($('.js__goods .pagination').length != 0) {
                        paginationLinkFix();
                    }
                    loadFilters(filters, typePage, scrollWrapFilters);
                }
            });
        } else if (typeof search_page !== 'undefined') {
            $.post(request.loadGoodSearch, {
                "filters": filters,
                "lang": lang,
                "query": search_page
            }, function (data) {
                if (data.status == 'ok') {
                    $('.js__goods').empty().append(data.html);
                    $('.js__count').empty().append(data.count);

                    if ($(window).width() >= 769) {
                        if (type_row_naw == 'row') {
                            $('.tile_item_wrap').addClass('row_tile js_row_tile');
                            alignmentTileGlobal('row');
                        } else {
                            alignmentTileGlobal('rows');
                        }
                    } else {
                        alignmentTileGlobal('rows');
                    }
                    lazyLoad();

                    if ($('.js__goods .pagination').length != 0) {
                        paginationLinkFix();
                    }
                    loadFilters(filters, typePage, scrollWrapFilters);
                }
            });
        } else if (typeof load_new_good !== 'undefined' && load_new_good) {
            $.post(request.loadNewGoods, {
                "filters": filters,
                "lang": lang,
            }, function (data) {
                if (data.status == 'ok') {
                    $('.js__goods').empty().append(data.html);
                    $('.js__count').empty().append(data.count);

                    if ($(window).width() >= 769) {
                        if (type_row_naw == 'row') {
                            $('.tile_item_wrap').addClass('row_tile js_row_tile');
                            alignmentTileGlobal('row');
                        } else {
                            alignmentTileGlobal('rows');
                        }
                    } else {
                        alignmentTileGlobal('rows');
                    }
                    lazyLoad();

                    if ($('.js__goods .pagination').length != 0) {
                        paginationLinkFix();
                    }
                    loadFilters(filters, typePage, scrollWrapFilters);
                }
            });
        } else if (typeof load_promo_good !== 'undefined' && load_promo_good) {
            $.post(request.loadPromoGoods, {
                "filters": filters,
                "lang": lang,
            }, function (data) {
                if (data.status == 'ok') {
                    $('.js__goods').empty().append(data.html);
                    $('.js__count').empty().append(data.count);

                    if ($(window).width() >= 769) {
                        if (type_row_naw == 'row') {
                            $('.tile_item_wrap').addClass('row_tile js_row_tile');
                            alignmentTileGlobal('row');
                        } else {
                            alignmentTileGlobal('rows');
                        }
                    } else {
                        alignmentTileGlobal('rows');
                    }
                    lazyLoad();

                    if ($('.js__goods .pagination').length != 0) {
                        paginationLinkFix();
                    }
                    loadFilters(filters, typePage, scrollWrapFilters);
                }
            });
        } else if (typeof load_actions_good !== 'undefined' && load_actions_good) {
            $.post(request.loadActionsGoods, {
                "filters": filters,
                "lang": lang,
            }, function (data) {
                if (data.status == 'ok') {
                    $('.js__goods').empty().append(data.html);
                    $('.js__count').empty().append(data.count);

                    if ($(window).width() >= 769) {
                        if (type_row_naw == 'row') {
                            $('.tile_item_wrap').addClass('row_tile js_row_tile');
                            alignmentTileGlobal('row');
                        } else {
                            alignmentTileGlobal('rows');
                        }
                    } else {
                        alignmentTileGlobal('rows');
                    }
                    lazyLoad();

                    if ($('.js__goods .pagination').length != 0) {
                        paginationLinkFix();
                    }
                    loadFilters(filters, typePage, scrollWrapFilters);
                }
            });
        } else if (typeof load_brand_goods !== 'undefined' && load_brand_goods) {
            $.post(request.loadBrandGoods, {
                "filters": filters,
                "nom_cat_id": (nom_cat_id != "") ? nom_cat_id : "",
                "model_list_id": (model_list_id != "") ? model_list_id : "",
                "lang": lang
            }, function (data) {
                if (data.status == 'ok') {
                    $('.js__goods').empty().append(data.html);
                    $('.js__count').empty().append(data.count);

                    if ($(window).width() >= 769) {
                        if (type_row_naw == 'row') {
                            $('.tile_item_wrap').addClass('row_tile js_row_tile');
                            alignmentTileGlobal('row');
                        } else {
                            alignmentTileGlobal('rows');
                        }
                    } else {
                        alignmentTileGlobal('rows');
                    }
                    lazyLoad();

                    if ($('.js__goods .pagination').length != 0) {
                        paginationLinkFix();
                    }
                    loadFilters(filters, typePage, scrollWrapFilters);
                }
            });
        } else if (typeof loadLeads !== 'undefined' && loadLeads) {
            $.post(request.loadLeads, {
                "filters": filters,
                "lang": lang,
            }, function (data) {
                if (data.status == 'ok') {
                    $('.js__leads_block').empty().append(data.html);
                    loadFilters(filters, typePage, scrollWrapFilters);
                }
            });
        } else {
            $.post(request.loadGoods, {
                "filters": filters,
                "nom_cat_id": (nom_cat_id != "") ? nom_cat_id : "",
                "model_list_id": (model_list_id != "") ? model_list_id : "",
                "lang": lang
            }, function (data) {
                if (data.status == 'ok') {
                    $('.js__goods').empty().append(data.html);
                    $('.js__count').empty().append(data.count);

                    if ($(window).width() >= 769) {
                        if (type_row_naw == 'row') {
                            $('.tile_item_wrap').addClass('row_tile js_row_tile');
                            alignmentTileGlobal('row');
                        } else {
                            alignmentTileGlobal('rows');
                        }
                    } else {
                        alignmentTileGlobal('rows');
                    }
                    lazyLoad();

                    if ($('.js__goods .pagination').length != 0) {
                        paginationLinkFix();
                    }
                    loadFilters(filters, typePage, scrollWrapFilters);
                }
            });
        }
    }

    window.rangePrice = rangePrice;
});